import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {SigninComponent} from './signin/signin.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import{EditProfileComponent} from './edit-profile/edit-profile.component';
import { LayoutComponent } from './layout/layout.component';
import { PostloginLayoutComponent } from './postlogin-layout/postlogin-layout.component';
import { AuthGuard } from './guards/auth.guard';
import { AdminAuthGuard } from './guards/admin.auth.guard';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { AdminHeaderComponent } from './admin-header/admin-header.component';
import { WebsiteDetailComponent } from './website-detail/website-detail.component';
import {InfoPanelComponent} from './info-panel/info-panel.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from './alert/alert.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import { TopBarLayoutComponent } from './top-bar-layout/top-bar-layout.component';
import { SupportComponent } from './support/support.component';
const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', component: SigninComponent },
      { path: 'signin', component: SigninComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'signin2', component: AdminLoginComponent },
    ]
  },
  {
    path: '',
    component: AdminHeaderComponent,
    children: [
    { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)}],
    
    canActivate: [AdminAuthGuard]
  },
  
  {
    path: 'insights',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./insights/insights.module').then(x => x.InsightsModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'bots',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./bots/bots.module').then(x => x.BotsModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'miniapps',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./mini-apps/miniapps.module').then(x => x.MiniAppssModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'post-hub',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./post-hub/post-hub.module').then(x => x.PostHubModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'templates',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./templates/templates.module').then(x => x.TemplatesModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'pricing',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./pricing/pricing.module').then(x => x.PricingModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'policies',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./policies/policies.module').then(x => x.PoliciesModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'documents',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./documents/documents.module').then(x => x.DocumentsModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'custom-code',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./custom-code/custom-code.module').then(x => x.CustomCodeModule)
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-profile',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', component: EditProfileComponent
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'business-detail',
    component: TopBarLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./business-detail/business-detail.module').then(x => x.BusinessDetailModule),
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'business-documents',
    component: TopBarLayoutComponent,
    children: [
      {
        path: '', loadChildren: () => import('./business-documents/business-documents.module').then(x => x.BusinessDocumentsModule),
      }
    ],
    canActivate: [AuthGuard]
  },  
  {
    path: 'info-panel',
    component: TopBarLayoutComponent,
    children: [
      {
        path: '', component: InfoPanelComponent,
      }
    ],
    canActivate: [AuthGuard]
  },  
  {
    path: 'website-detail',
    component: TopBarLayoutComponent,
    children: [
      {
        path: '', component: WebsiteDetailComponent,
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'help-support',
    component: PostloginLayoutComponent,
    children: [
      {
        path: '', component: SupportComponent,
      }
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [
    LayoutComponent,
    PostloginLayoutComponent,
    AdminHeaderComponent,
    WebsiteDetailComponent,
    InfoPanelComponent,
    TopBarLayoutComponent,
  ],
  imports: [
    RouterModule.forRoot(routes),
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatMenuModule,
    MatIconModule,
    CommonModule,
    NgxDropzoneModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule,
    MatFormFieldModule,
    FlexLayoutModule
  ],
  exports: [
    RouterModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatMenuModule,
    MatIconModule,
    CommonModule,
    NgxDropzoneModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule,
    MatFormFieldModule
  ]
})
export class AppRoutingModule { }
